<template>
  <section class="content">
    <el-row v-if="title" style="background-color: #f8f8f8">
      <el-col :span="24"><h4 style="text-align: left">{{title}}</h4></el-col>
    </el-row>
    <div style="margin-top: 10px">
      <el-table
        style="text-align: center"
        :border="true"
        :header-row-class-name="'headerTable'"
        :data="tableData">
        <el-table-column v-for="item in labelData"
                         :key="item.title"
                         show-overflow-tooltip
                         header-align="center"
                         :label="item.title"
                         :min-width="item.size">
          <template slot-scope="scope">
            {{scope.row[item.attr]}}
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-row v-if="exportData.show" style="margin-top: 10px;text-align: left"> -->
      <!-- <el-row style="margin-top: 10px;text-align: left">
        <el-col :span="12">
          <el-button type="primary" :loading="loading" size="small" @click="exportFn">数据导出</el-button>
        </el-col>
      </el-row> -->
    </div>
  </section>
</template>
<script type="text/babel">
  import { Utils } from '../../../utils/utils'

  export default {
    name: 'commonTable',
    props: {
      /*
       * 组件数据
       * */
      tableData: {
        type: Array,
        required: true,
        default () {
          return [{
            number: '1',
            name: '1',
            num: '10'
          }]
        }
      },
      /*
       * 表格标题
       * */
      title: {
        type: String,
        default () {
          return ''
        }
      },
      /*
       * 表头目录
       * */
      label: {
        type: Array,
        required: true,
        default () {
          return ['货号', '商品名', '药品数量']
        }
      },
      /*
       * 表头ID
       * */
      labelId: {
        type: Array,
        required: true,
        default () {
          return ['number', 'name', 'num']
        }
      },
      /*
       * 表头尺寸（默认最小值为65）
       * */
      labelSize: {
        type: Array,
        default () {
          const sizeArray = []
          this.label.forEach((ele) => {
            sizeArray.push('65')
          })
          return sizeArray
        }
      },
      /*
       * 表头视图
       * */
      labelView: {
        type: String,
        default () {
          return '药品数量'
        }
      },
      /*
       * 数据导出
       * */
      exportData: {
        type: Object,
        default () {
          return {
            show: false,
            data: [],
            name: '表格',
            type: []
          }
        }
      },
      /*
       * 数据导出回掉函数
       * */
      exportFn: {
        type: Function,
        default () {
          return function () {
          }
        }
      },
      /*
       * 数据导出按钮加载效果
       * */
      loading: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        labelData: []
      }
    },
    mounted () {
    },
    watch: {
      'tableData': 'init',
      'exportData.data': 'exportExcel'
    },
    methods: {
      init () {
        const vm = this
        vm.labelData = []
        let maxNum
        vm.tableData.forEach((ele, index) => {
          if (typeof maxNum !== 'undefined') {
            if (Math.round(maxNum.num) < Math.round(ele.num)) {
              maxNum = ele
            }
          } else {
            maxNum = ele
          }
        })
        vm.label.forEach((element, index) => {
          vm.labelData.push({
            title: element,
            size: vm.labelSize[index] || '65',
            view: element === vm.labelView,
            attr: vm.labelId[index] || '',
            viewSize: Math.round(maxNum.num)
          })
        })
      },
      labelStyle (attr, viewSize) {
        return { width: (Math.round(attr) / viewSize) * 80 + '%' }
      },
      exportExcel () {
        const vm = this
        Utils.JSONToExcelExportBase(vm.exportData.data, vm.exportData.name, vm.exportData.type, 1500)
      }
    },
    components: {}
  }
</script>

<style scoped>
  .headerTable {
    background-color: #f8f8f8;
  }

  .labelView {
    height: 25px;
    background-color: #3388ff;
  }
</style>
